import { Component, OnInit, Input, Type } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  FormArray,
} from '@angular/forms';
import { VehicleService } from 'src/app/vehicles/services/vehicle.service';
import { AlertService, TypeAlert } from 'src/app/alertas/services/alert.service';
import { Select2Data, Select2Group, Select2Option } from 'ng-select2-component';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { PanelService } from 'src/app/panel/services/panel.service';
import { GeofencesService } from 'src/app/geofences/services/geofences.service';
import { AssociationService } from 'src/app/vehicles/services/association.service';
import { Op } from 'src/app/multiview/models/interfaces';
import { NgxSpinnerService } from 'ngx-spinner';
import { TreeNode } from 'primeng-lts/api';


@Component({
  selector: 'app-alert-form',
  templateUrl: './alert-form.component.html',
  styleUrls: ['./alert-form.component.scss']
})
export class AlertFormComponent implements OnInit {

  @Input() type: 'edit' | 'create' = 'create'
  @Input() typeAlert!: TypeAlert


  public eventTypeSelected: boolean = false;
  // OPTIONS FORM (show more option in the Form)
  public showGeocercas = false;
  public showMoreFiltersGeocercas = false
  public showInfraccion = false;
  public showTolerance = false;
  public showWhatsApp = false;
  // config
  public showTiempoLimite = false;
  public showInfraccionGeocerca = false;
  public loadingEventSelectInput: boolean = true;
  public vehiclesSelected: string[] = [];
  public geoSelected: string[] = [];

  // control loading
  loadingAlertDropdownReady: boolean = false;
  loadingVehicleMultiselectReady: boolean = false;
  loadingGeofencesMultiselectReady: boolean = false;

  // permisos
  public eventAttentionPermission: string = ""
  public emailNotificationPermission: string = '';
  public whatsappNotificationPermission: string = '';


  // util options support
  public booleanOptions = [
    { label: 'Sí', value: true },
    { label: 'No', value: false },
  ];
  public booleanOptionsVentanaEmergente = [
    { label: 'Activado', value: true },
    { label: 'Desactivado', value: false },
  ];
  public booleanOptionsAtencionEventos = [
    { label: 'Activado', value: true },
    { label: 'Desactivado', value: false },
  ];
  public timeFormatOptions = [
    { label: 'segundos', value: 'S' },
    { label: 'minutos', value: 'M' },
    { label: 'horas', value: 'H' },
  ];
  public fijarTiempoOptions = [
    { label: '10 Seg.', value: 10 },
    { label: '30 Seg.', value: 30 },
    { label: '1 Min.', value: 60 },
    { label: '2 Min.', value: 120 },
  ];
  public codes: any = [] // telefonos codigos

  public temperatureMaxLimit = 180;
  public temperatureMinLimit = -40;
  public humidityMinLimit = 0;
  public humidityMaxLimit = 100;

  // Configuración para multi-sensores
public multiSensorLimits: Record<string, { min: number; max: number }> = {
  'multi-temperatura': { min: -40, max: 180 },
  'multi-humedad': { min: 0, max: 100 }
};

  // options
  public events: any = [];
  public vehicles: (Select2Group & { operation: number, grupo: number, convoy: number } | Select2Option & { operation: number, grupo: number, convoy: number })[] = [];
  public geocercas: Select2Data = [];
  public geocercasFiltradas: Select2Data = [];
  public listaSonidos: any = []
  public association: Op[] = [];

  // util values support
  public codeSelected: number = 51;

  // FORM
  public alertForm!: FormGroup;
 
  // -----
  public showMultiSensorConfig = false;
  public multiSensorData: any[] = [];
  // Para rastrear nuevos sensores (animación)
  private newSensorIds: Set<number> = new Set();

  // UTIL SUPORT
  public labelDescriptionFilterVehicle?: string;
  public alertSelected: any;
  public treeAssociation: any;
  public treeAssociationSelected: any;

  public listOperations: any[] = []
  public listEtiquetas: any[] = []
  public listGeocercas: any[] = []

  public selectedOperations: any = []
  public selectedEtiquetas: any = []

  constructor(
    private alertService: AlertService,
    private vehicleService: VehicleService,
    private formBuilder: FormBuilder,
    public panelService: PanelService,
    private geofencesService: GeofencesService,
    public associationService: AssociationService,
    private spinner: NgxSpinnerService
  ) { }

  async ngOnInit(): Promise<void> {
    //this.listaSonidos = [...this.alertService.listaSonidos];
    this.codes = this.alertService.codes;
    this.spinner.show('loadingAlertData');
    this.loadAssociation()
    this.loadPermission();
    if (this.type == "create") {
      this.loadNewForm()
    } else {
      await this.loadEditForm()
    }
    this.initializeDefaultSensor();
    this.initFormChangeSubscriptions();
    this.loadData().then(() => {
      this.loadConfigAditionalFormItem();
    })
  }
  private loadPermission() {
    this.eventAttentionPermission = this.type === 'create'
      ? 'alerts_eventattention_whencreate'
      : 'alerts_eventattention_whenupdate';
    this.emailNotificationPermission = this.type == "create"
      ? 'alerts_email_whencreate'
      : 'alerts_email_whenupdate'
    this.whatsappNotificationPermission = this.type == "create"
      ? 'alerts_whatsapp_whencreate'
      : 'alerts_whatsapp_whenupdate'
  }
  private async loadData() {
    this.events = await this.alertService.getEventsByType(this.typeAlert);
    this.events.sort((a:any, b:any) => a.name.localeCompare(b.name));
    console.log(this.events, "get the alert configt selected",this.alertForm.getRawValue())
    const alert = this.events.find(
      (event: any) =>
        event.id.toString() === this.alertForm.getRawValue().tipoAlerta.toString()
    );
    console.log(alert, this.events, "show alert", this.alertForm.getRawValue().tipoAlerta.toString())
    if (alert) {
      this.alertSelected = alert
      this.updateSoundSystem(alert);
      this.updateValueValidators(alert.slug || "")
    }
    this.loadingEventSelectInput = false;
    this.setDataVehicles()
    this.initControlStates();
    this.setDataGeofences().then(() => {
      this.loadingAlertDropdownReady = true;
      this.hideLoadingSpinner();
    });
  }
  // Init Form Alert
  private loadNewForm() {
    this.alertForm = this.formBuilder.group({
      // configuracion basica
      eventType: [this.typeAlert],
      tipoAlerta: ['', [Validators.required]],
      nombre: ['', [Validators.required]],
      // seleccion de vehiculos
      vehicles: ['', [Validators.required]],
      // configuracion de alertas
      chkEventoActivado: [true],
      chkSonido: [false], // especial
      sonido: [{ value: 'sonidos/alarm8.mp3', disabled: false,}],
      chkVentanaEmergente: [false],
      chkEvaluation: [false],

      // notificacion por email
      chkCorreo: [false],
      lista_emails: [[]],
      email: [
        { value: '', disabled: true },
        [Validators.required, Validators.email],
      ],

      chkCaducidad: [false], // ??


      chkwhatsapp: [false],
      lista_whatsapp: [[]],
      whatsapp: [
        { value: '', disabled: true },
        [Validators.required],
      ],

      velocidad_limite_infraccion: [{ value: '', disabled: false }],
      duracion_formato_parada: ['S'],
      tiempo_limite_infraccion: [
        { value: '', disabled: true },
      ],

      geocercas: [[]],
      chkFijarTiempo: [false],
      chkDuracionParada: [false],
      duracion_parada: [0],
      chkFijarLimiteVelocidad: [true],

      value_min: [null],
      value_max: [null],

      // Campos para multi-sensores
      multi_sensor_config: [[]],
    });
  }
  private async loadEditForm() {
    let alert = this.alertService.getAlertEditData();
    this.eventTypeSelected=true;
    console.log("show alert to edit", alert)
    this.vehiclesSelected = alert.vehicleIds === ''
      ? []
      : alert.vehicleIds.split(',').map(Number);

    let arrayNotificationSystem = alert.sistema_notificacion.split(',');
    const notificacion_system = arrayNotificationSystem[2].toLowerCase() === 'true';

    let emails = alert.notificacion_direcion_email == '' ? []
      : alert.notificacion_direcion_email.split(',');

    let whatsapps;
    let notificacion_whatsapp = alert.notificacion_whatsapp.toLowerCase() === 'true';
    if (
      alert.notificacion_whatsapp_lista == null ||
      alert.notificacion_whatsapp_lista == ''
    ) {
      whatsapps = [];
    } else {
      whatsapps = alert.notificacion_whatsapp_lista.split(',');
    }

  let multiSensorData = [];

  try {
      const parsedValue = JSON.parse(alert.valor_verificado);

      if (
        Array.isArray(parsedValue) &&
        parsedValue.length > 0 &&
        parsedValue[0].sensor !== undefined
      ) {
        multiSensorData = parsedValue.map((item: any) => ({
          ...item,
          active: item.active !== undefined ? item.active : true, // Si no tiene active, por defecto true
        }));
        this.showMultiSensorConfig = true;
      } else {
        multiSensorData = [
          {
            sensor: 1,
            value_min: null,
            value_max: null,
            active: true,
          },
        ];
      }
  } catch (error) {
    this.geoSelected = alert.valor_verificado === ''
      ? []
      : alert.valor_verificado.split(',').map(Number);

  }
   this.multiSensorData = multiSensorData;

    this.alertForm = this.formBuilder.group({
      id: [alert.id],
      eventType: [this.typeAlert],
      tipoAlerta: new FormControl(
        { value: alert.event_id, disabled: this.type == 'edit' },
        [Validators.required],
      ),
      nombre: [alert.nombre],
      vehicles: [this.vehiclesSelected, [Validators.required]],
      chkEventoActivado: [alert.activo === 'true'],
      chkSonido: [notificacion_system],
      sonido: [`sonidos/${arrayNotificationSystem[3]}`],
      chkVentanaEmergente: [alert.ventana_emergente.toLowerCase() === 'true'],
      chkEvaluation: [alert.bol_evaluation],
      chkCorreo: [alert.notificacion_email.toLowerCase() === 'true'],
      lista_emails: [emails],
      email: [
        {
          value: '',
          disabled: alert.notificacion_email.toLowerCase() != 'true',
        },
        [Validators.required, Validators.email],
      ],

      chkCaducidad: [alert.bol_fecha_caducidad],
      chkwhatsapp: [notificacion_whatsapp],
      whatsapp: [
        { value: '', disabled: !notificacion_whatsapp },
        [Validators.required],
      ],
      lista_whatsapp: [whatsapps],

      velocidad_limite_infraccion: [
        {
          value: alert.velocidad_limite_infraccion,
          disabled: !alert.bol_fijar_velocidad,
        },
      ],
      duracion_formato_parada: [alert.duracion_formato_parada],
      tiempo_limite_infraccion: [
        {
          value: alert.tiempo_limite_infraccion,
          disabled: !alert.bol_fijar_tiempo,
        },
      ],
      geocercas: [this.geoSelected],
      chkFijarTiempo: [
        { value: alert.bol_fijar_tiempo, disabled: alert.bol_fijar_velocidad },
      ],
      duracion_parada: [alert.duracion_parada],
      chkFijarLimiteVelocidad: [
        { value: alert.bol_fijar_velocidad, disabled: alert.bol_fijar_tiempo },
      ],
      value_min: [alert.value_min],
      value_max: [alert.value_max],
      multi_sensor_config: [this.multiSensorData],
    });
    return
  }


  private initControlStates() {
    const config = [
      { check: 'chkSonido', control: 'sonido' },
      { check: 'chkCorreo', control: 'email' },
      { check: 'chkwhatsapp', control: 'whatsapp' },
      { check: 'chkFijarLimiteVelocidad', control: 'velocidad_limite_infraccion' }
    ];

    config.forEach(({ check, control }) => {
      const isChecked = this.alertForm.get(check)?.value;
      const targetControl = this.alertForm.get(control);
      if (isChecked) {
        targetControl?.enable({ emitEvent: false });
      } else {
        targetControl?.disable({ emitEvent: false });
      }
    });
  }

  private initFormChangeSubscriptions() {
    // control disabled
    this.alertForm.get('chkSonido')?.valueChanges.subscribe((value) => {
      const sonidoCtrl = this.alertForm.get('sonido');
      if (value) {
        sonidoCtrl?.enable();
      } else {
        sonidoCtrl?.disable();
      }
    });
    this.alertForm.get('chkCorreo')?.valueChanges.subscribe((value) => {
      const sonidoCtrl = this.alertForm.get('email');
      if (value) {
        sonidoCtrl?.enable();
      } else {
        sonidoCtrl?.disable();
      }
    });

    this.alertForm.get('chkwhatsapp')?.valueChanges.subscribe((value) => {
      const sonidoCtrl = this.alertForm.get('whatsapp');
      if (value) {
        sonidoCtrl?.enable();
      } else {
        sonidoCtrl?.disable();
      }
    });

    this.alertForm.get("chkFijarLimiteVelocidad")?.valueChanges.subscribe((value) => {
      const sonidoCtrl = this.alertForm.get('velocidad_limite_infraccion');
      if (value) {
        sonidoCtrl?.enable();
      } else {
        sonidoCtrl?.disable();
      }
    })


    this.alertForm.get("tipoAlerta")?.valueChanges.subscribe((value) => {
      const alert = this.events.find((event: any) =>
        event.id.toString() === value.toString()
      );
      console.log(alert, "alert selected type")
      if (alert) {
        this.alertSelected = alert
        this.eventTypeSelected = true;
        this.updateSoundSystem(alert)
        this.loadConfigAditionalFormItem()
        this.updateValueValidators(alert.slug || "");
      }
    })
  }
public isNewSensor(sensorId: number): boolean {
  return this.newSensorIds.has(sensorId);
}
  // Inicializar con un sensor por defecto
private initializeDefaultSensor() {
  if (this.multiSensorData.length === 0) {
    this.multiSensorData = [
      {
        sensor: 1,
        value_min: null,
        value_max: null,
        active: true,
      },
    ];
  }
}
// Método para añadir nuevo sensor
public addNewSensor(): void {
  if (this.multiSensorData.length >= 4) {
    Swal.fire(
      'Límite alcanzado', 
      'Solo se pueden configurar hasta 4 sensores.', 
      'warning'
    );
    return;
  }

  // Buscar el siguiente número de sensor disponible
  const usedSensors = this.multiSensorData.map(s => s.sensor);
  let nextSensorNumber = 1;
  while (usedSensors.includes(nextSensorNumber)) {
    nextSensorNumber++;
  }

  const newSensor = {
    sensor: nextSensorNumber,
    value_min: null,
    value_max: null,
    active: true,
  };

  // Marcar como nuevo para animación
  this.newSensorIds.add(nextSensorNumber);
  
  // Añadir el nuevo sensor
  this.multiSensorData = [...this.multiSensorData, newSensor];
  
  // Actualizar el formulario
  this.updateMultiSensorConfig();
  
  // Remover la marca de nuevo después de la animación
  setTimeout(() => {
    this.newSensorIds.delete(nextSensorNumber);
  }, 300);
}
// Método para eliminar sensor
public removeSensor(index: number): void {
  if (this.multiSensorData.length <= 1) {
    Swal.fire('Error', 'Debe tener al menos un sensor configurado.', 'warning');
    return;
  }

  const sensorToRemove = this.multiSensorData[index];
  
  Swal.fire({
    title: '¿Eliminar sensor?',
    text: `¿Estás seguro de eliminar el Sensor ${sensorToRemove.sensor}?`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar'
  }).then((result) => {
    if (result.isConfirmed) {
      this.multiSensorData = this.multiSensorData.filter((_, i) => i !== index);
      this.updateMultiSensorConfig();
    }
  });
}
// Método para cuando se cambia el toggle de un sensor
public onSensorToggleChange(index: number): void {
  const sensor = this.multiSensorData[index];
  if (sensor) {
    // Si se desactiva, limpiar validaciones
    if (!sensor.active) {
      // Opcional: resetear valores cuando se desactiva
      // sensor.value_min = null;
      // sensor.value_max = null;
    }
    this.updateMultiSensorConfig();
  }
}

  // Obtiene el valor mínimo según el ID del sensor
getSensorMinValue(sensorId: number): number | null {
  const sensorData = this.multiSensorData?.find(d => d.sensor === sensorId);
  return sensorData ? sensorData.value_min : null;
}

// Obtiene el valor máximo según el ID del sensor
getSensorMaxValue(sensorId: number): number | null {
  const sensorData = this.multiSensorData?.find(d => d.sensor === sensorId);
  return sensorData ? sensorData.value_max : null;
}
  // Métodos para multi-sensores
  public checkMultiSensorVisibility(slug: string) {
    const isMultiSensor =
      slug === 'multi-temperatura' || slug === 'multi-humedad';
    this.showMultiSensorConfig = isMultiSensor;

    if (isMultiSensor) {
      // Inicializar datos si no existen
      if (this.multiSensorData.length === 0) {
        this.multiSensorData = [];
      }
    } else {
      // Limpiar datos cuando no es multi-sensor
      // this.selectedSensors = [];
      this.multiSensorData = [];
    }
  }

  // public onSensorSelectionChange() {
  //   // Inicializar datos para los sensores seleccionados
  //   const currentData = [...this.multiSensorData];
  //   console.log(this.multiSensorData,'-------------------');
    
  //   this.multiSensorData = this.selectedSensors.map((sensorId) => {
  //     const existing = currentData.find((d) => d.sensor === sensorId);
  //     return (
  //       existing || {
  //         sensor: sensorId,
  //         value_min: null,
  //         value_max: null,
  //       }
  //     );
  //   });
  //   this.updateMultiSensorConfig();
  // }

  public updateSensorValue(
    index: number,
    field: 'value_min' | 'value_max',
    value: number | null,
  ) {
   if (this.multiSensorData[index]) {
    this.multiSensorData[index][field] = value;
    this.updateMultiSensorConfig();
  }
  }

  private updateMultiSensorConfig() {
     // Guardar en el formulario para enviar al backend
  const configValue = this.multiSensorData.length > 0 
    ? JSON.stringify(this.multiSensorData) 
    : null;
  
  this.alertForm.get('multi_sensor_config')?.setValue(configValue);
  
  // También actualizar valor_verificado si es necesario
  // (dependiendo de cómo maneje el backend)
  if (this.alertSelected?.slug === 'multi-temperatura' || 
      this.alertSelected?.slug === 'multi-humedad') {
    // El backend espera el JSON en valor_verificado
    this.alertForm.get('multi_sensor_config')?.setValue(
      this.multiSensorData
    );
  }
  }

  public getSensorLabel(sensorId: number): string {
    return `Sensor ${sensorId}`;
  }

  public getMinLimit(): number {
  if (!this.alertSelected?.slug) return 0;
  return this.multiSensorLimits[this.alertSelected.slug]?.min ?? 0;
}

public getMaxLimit(): number {
  if (!this.alertSelected?.slug) return 100;
  return this.multiSensorLimits[this.alertSelected.slug]?.max ?? 100;
}

  public getUnitLabel(): string {
    if (!this.alertSelected?.slug) return '';
    return this.alertSelected.slug === 'multi-temperatura' ? '°C' : '%';
  }

  public validateMultiSensorData(): boolean {
    if (this.multiSensorData.length === 0) {
        Swal.fire('Error', 'Debe configurar al menos un sensor.', 'warning');
        return false;
    };

   for (let i = 0; i < this.multiSensorData.length; i++) {
     const data = this.multiSensorData[i];

     // Validar que al menos uno de los valores esté configurado
     if (data.value_min == null && data.value_max == null) {
       Swal.fire(
         'Error',
         `Debe configurar al menos un valor mínimo o máximo para el Sensor ${data.sensor}`,
         'warning',
       );
       return false;
     }

     const minLimit = this.getMinLimit();
     const maxLimit = this.getMaxLimit();

     // Validar rango mínimo
     if (
       data.value_min != null &&
       (data.value_min < minLimit || data.value_min > maxLimit)
     ) {
       Swal.fire(
         'Error',
         `El valor mínimo del Sensor ${data.sensor} debe estar entre ${minLimit} y ${maxLimit}`,
         'warning',
       );
       return false;
     }

     // Validar rango máximo
     if (
       data.value_max != null &&
       (data.value_max < minLimit || data.value_max > maxLimit)
     ) {
       Swal.fire(
         'Error',
         `El valor máximo del Sensor ${data.sensor} debe estar entre ${minLimit} y ${maxLimit}`,
         'warning',
       );
       return false;
     }

     // Validar que mínimo <= máximo
     if (
       data.value_min != null &&
       data.value_max != null &&
       data.value_min > data.value_max
     ) {
       Swal.fire(
         'Error',
         `El valor mínimo no puede ser mayor que el máximo para el Sensor ${data.sensor}`,
         'warning',
       );
       return false;
     }
   }

    return true;
  }
// Método para obtener solo sensores activos (si lo necesitas)
public getActiveSensors(): any[] {
  return this.multiSensorData.filter(s => s.active);
}

// Método para obtener sensores inactivos (si lo necesitas)
public getInactiveSensors(): any[] {
  return this.multiSensorData.filter(s => !s.active);
}
  // value min and max
  public updateValueValidators(slug: string) {
    const minCtrl = this.alertForm.get('value_min');
    const maxCtrl = this.alertForm.get('value_max');

    console.log("alert-form : update the value validation to ", slug)
    // Elimina validadores previos
    minCtrl?.clearValidators();
    maxCtrl?.clearValidators();

    if (slug === 'temperatura') {
      minCtrl?.setValidators([
        Validators.min(this.temperatureMinLimit),
        Validators.max(this.temperatureMaxLimit),
      ]);
      maxCtrl?.setValidators([
        Validators.min(this.temperatureMinLimit),
        Validators.max(this.temperatureMaxLimit),
      ]);
    } else if (slug === 'humedad') {
      minCtrl?.setValidators([
        Validators.min(this.humidityMinLimit),
        Validators.max(this.humidityMaxLimit),
      ]);
      maxCtrl?.setValidators([
        Validators.min(this.humidityMinLimit),
        Validators.max(this.humidityMaxLimit),
      ]);
    }

    // 👇 Refresca el estado del formulario
    minCtrl?.updateValueAndValidity();
    maxCtrl?.updateValueAndValidity();
  }
  private resetConfigFlags() {
    this.showGeocercas = false;
    this.showWhatsApp = false;
    this.showInfraccion = false;
    this.showTiempoLimite = false;
    this.showTolerance = false;
  }
  private loadConfigAditionalFormItem() {
    console.log(this.alertSelected, "init config alert sections")
    this.resetConfigFlags()
    switch (this.typeAlert) {
      case TypeAlert.PLATAFORM:
        this.showGeocercas = true;
        break
      case TypeAlert.ALERT_360:
        this.showWhatsApp = true;
        break
    }

    if(!this.alertSelected){return}

    switch (this.alertSelected["slug"]) {
      case "infraccion":
        this.showInfraccion = true;
        this.alertForm.get("chkFijarLimiteVelocidad")?.setValue(true); // esto sí dispara el valueChanges
        if (this.typeAlert == TypeAlert.PLATAFORM) {
          this.showGeocercas = false;
        }
        break;
      case "transito-lento":
        this.showTiempoLimite = true;
        this.showTolerance = true;
        break;
      case "parada-en-zona-no-autorizada":
      case "parada-en-zona-no-programada":
      case "tiempo-estadio-zona":
      case "exceso-velocidad-duracion-direccion":
        this.showTiempoLimite = true;
        break
      case "infraccion-geocerca-direccion":
      case "infraccion-geocerca":
        this.showTolerance = true;
    }
  }

  // filters
  public changeVehicles(event: any) {
    const operations = new Set();
    this.geocercasFiltradas = this.geocercas.filter((geofence) =>
      operations.has(geofence.templateId)
    );
    const geocercasVehicles = this.listGeocercas

    let geocercasFiltradas = geocercasVehicles
    if (this.showMoreFiltersGeocercas) {
      console.log(geocercasVehicles, "geocercas filters")
      geocercasFiltradas = geocercasVehicles.filter((geo) => {
        const geotags = geo.tags || []; // Asegurar que exista una lista
        const matchOperacion = this.selectedOperations.includes(geo.idoperation);

        const sinEtiquetaSelected = this.selectedEtiquetas.includes(0);

        let matchEtiqueta = false
        if (sinEtiquetaSelected && geotags.length == 0) {
          matchEtiqueta = true
        } else {
          matchEtiqueta = geotags.some((tag: any) => this.selectedEtiquetas.includes(tag));
        }
        return matchOperacion && matchEtiqueta;
      });
    }

    this.geocercasFiltradas = geocercasFiltradas.map((geocerca: any) => ({
      value: geocerca.id,
      label: geocerca.zone_name,
      templateId: geocerca.idoperation,
      color: geocerca.zone_color,
      type: geocerca.type || "polig"
    }));
    console.log(geocercasFiltradas, "geocercas filters final")

  }

  // input and control event

  public onSubmit(event: any) {
    event.preventDefault();

    const formData = { ...this.alertForm.getRawValue() };

    // Agregar valores derivados
    formData.vehiclesIds = JSON.stringify(formData.vehicles);
    formData.geocercas = JSON.stringify(formData.geocercas);
    console.log(formData, "data from form to analizay")
    // Validaciones
    if (formData.chkCorreo && formData.lista_emails.length === 0) {
      Swal.fire('Error', 'Debe ingresar un correo', 'warning');
      return;
    }

    if (formData.chkwhatsapp && formData.lista_whatsapp.length === 0) {
      Swal.fire('Error', 'Debe ingresar un número', 'warning');
      return;
    }

    if (this.alertSelected?.slug === "temperatura") {
      const { value_min, value_max } = formData;

      // Validar que haya al menos un valor
      if (value_min == null && value_max == null) {
        Swal.fire('Error', 'Debe configurar una temperatura mínima o máxima', 'warning');
        return;
      }

      // Validar rango máximo
      if (value_max != null && (value_max < this.temperatureMinLimit || value_max > this.temperatureMaxLimit)) {
        Swal.fire(
          'Error',
          `Debe configurar una temperatura máxima entre ${this.temperatureMinLimit}°C y ${this.temperatureMaxLimit}°C`,
          'warning'
        );
        return;
      }

      // Validar rango mínimo
      if (value_min != null && (value_min < this.temperatureMinLimit || value_min > this.temperatureMaxLimit)) {
        Swal.fire(
          'Error',
          `Debe configurar una temperatura mínima entre ${this.temperatureMinLimit}°C y ${this.temperatureMaxLimit}°C`,
          'warning'
        );
        return;
      }

      // Validar relación mínima < máxima
      if (value_min != null && value_max != null && value_min > value_max) {
        Swal.fire('Error', 'La temperatura mínima no puede ser mayor que la máxima', 'warning');
        return;
      }
    }

    if (this.alertSelected?.slug === "humedad") {
      const { value_min, value_max } = formData;

      // Validar que haya al menos un valor
      if (value_min == null && value_max == null) {
        Swal.fire('Error', 'Debe configurar una humedad mínima o máxima', 'warning');
        return;
      }

      // Validar rango máximo
      if (value_max != null && (value_max < this.humidityMinLimit || value_max > this.humidityMaxLimit)) {
        Swal.fire(
          'Error',
          `Debe configurar una humedad máxima entre ${this.humidityMinLimit}% y ${this.humidityMaxLimit}%`,
          'warning'
        );
        return;
      }

      // Validar rango mínimo
      if (value_min != null && (value_min < this.humidityMinLimit || value_min > this.humidityMaxLimit)) {
        Swal.fire(
          'Error',
          `Debe configurar una humedad mínima entre ${this.humidityMinLimit}% y ${this.humidityMaxLimit}%`,
          'warning'
        );
        return;
      }

      // Validar relación mínima < máxima
      if (value_min != null && value_max != null && value_min > value_max) {
        Swal.fire('Error', 'La humedad mínima no puede ser mayor que la máxima', 'warning');
        return;
      }
    }

    // Log
    console.log(formData, "on submit alert data");

    // Validación final antes de enviar
    if (
      formData.vehicles.length !== 0 &&
      formData.nombre.trim() !== '' &&
      formData.tipoAlerta
    ) {
      Swal.fire({
        title: 'Desea guardar los cambios?',
        //text: 'Espere un momento...',
        icon: 'warning',
        showLoaderOnConfirm: true,
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonText: 'Guardar',
        cancelButtonText: 'Cancelar',
        preConfirm: async () => {
          if (this.type == "edit") {
            await this.alertService.edit(formData);
          } else {
            await this.alertService.create(formData)
          }
          this.alertService.getAll();
          this.clickShowPanel();
          return;
        },
      }).then((data) => {
        if (data.isConfirmed) {
          Swal.fire(
            'Actualizado',
            'Los datos se actualizaron correctamente!!',
            'success'
          );
        }
      });
    } else {
      if (this.alertForm.getRawValue().vehicles.length === 0) {
        Swal.fire(
          '¡Atención!',
          'Debe seleccionar al menos un vehículo para completar la acción.',
          'warning'
        );
      }
      if (this.alertForm.getRawValue().nombre.trim() === '') {
        Swal.fire(
          '¡Atención!',
          'Debe ingresar el nombre de la alerta',
          'warning'
        );
      }
      if (!this.alertForm.getRawValue().tipoAlerta) {
        Swal.fire(
          '¡Atención!',
          'Debe seleccionar el tipo de alerta',
          'warning'
        );
      }
    }
  }
  public selectMoreFiltersGeofences() {
    this.showMoreFiltersGeocercas = !this.showMoreFiltersGeocercas
    this.changeVehicles(true)
  }

  public addEmail() {
    if (this.alertForm.value.chkCorreo) {
      console.log("email send to addEmial", this.alertForm.value.email)
      if (this.validateEmail(this.alertForm.value.email)) {
        if (
          !this.isInArray(
            this.alertForm.value.email,
            this.alertForm.value.lista_emails
          )
        ) {
          if(this.alertForm.value.lista_emails.length >= 5){
            Swal.fire({
              title: 'Atención',
              text: 'Ha alcanzado el máximo de 5 correos electrónicos permitidos.',
              icon: 'warning',
            });
          } else {
            this.alertForm.value.lista_emails.push(this.alertForm.value.email);
            this.alertForm.controls.email.reset();
          }
        } else {
          Swal.fire({
            title: 'Error',
            text: 'El email ingresado ya existe.',
            icon: 'warning',
            allowOutsideClick: false,
          });
        }
      } else {
        Swal.fire({
          title: 'Error',
          text: 'Debe ingresar un email válido.',
          icon: 'warning',
          allowOutsideClick: false,
        });
      }
    }
  }
  public removeEmail(index: number) {
    this.alertForm.value.lista_emails.splice(index, 1);
  }
  public addWhatsapp() {
    if (this.alertForm.value.chkwhatsapp) {
      if (
        this.alertForm.value.whatsapp &&
        this.alertForm.value.whatsapp.toString().length > 8
      ) {
        if (
          !this.isInArray(
            `${this.codeSelected}${this.alertForm.value.whatsapp}`,
            this.alertForm.value.lista_whatsapp
          )
        ) {
          if(this.alertForm.value.lista_whatsapp.length >= 5){
            Swal.fire({
              title: 'Máximo permitido',
              text: 'Puede registrar hasta 5 números de WhatsApp como máximo.',
              icon: 'warning',
            });
          }else {
            this.alertForm.value.lista_whatsapp.push(
              `${this.codeSelected}${this.alertForm.value.whatsapp}`
            );
            this.alertForm.controls.whatsapp.reset();
          }
        } else {
          Swal.fire({
            title: 'Error',
            text: 'El número ingresado ya existe.',
            icon: 'warning',
          });
        }
      } else {
        Swal.fire({
          title: 'Error',
          text: 'Debe ingresar un número.',
          icon: 'warning',
        });
      }
    }
  }

  public removeWhatsapp(index : number) {
    this.alertForm.value.lista_whatsapp.splice(index, 1);
  }

  // loadData
  private loadAssociation() {
    this.associationService.getAssociation();
    this.association = this.associationService.association;
    this.treeAssociation = this.convertToTreeNodes(this.association)
  }
  public setDataVehicles() {
    let vehicles = []
    if (this.vehicleService.statusDataVehicle) {

      switch (this.typeAlert) {
        case TypeAlert.GPS:
          vehicles = this.vehicleService.getVehiclesGPS();
          break
        case TypeAlert.MOBILE:
          vehicles = this.vehicleService.getVehiclesGPS();
          break
        case TypeAlert.ALERT_360:
          vehicles = this.vehicleService.getVehiclesCipia();
          break
        case TypeAlert.SECURITY:
          vehicles = this.vehicleService.getVehiclesGPS();
          break
        case TypeAlert.PLATAFORM:
          vehicles = this.vehicleService.getVehiclesData();
          break
      }


      this.vehicles = vehicles.map((vehicle: any) => {
        return {
          value: vehicle.id,
          label: vehicle.name,
          templateId: vehicle.idoperation,
          operation: vehicle.idoperation,
          grupo: vehicle.idgrupo,
          convoy: vehicle.idconvoy,
        };
      });

      this.loadingVehicleMultiselectReady = true;
      this.hideLoadingSpinner();
    } else {
      this.vehicleService.dataCompleted.subscribe((vehicles) => {
        this.vehicles = vehicles.map((vehicle: any) => {
          return {
            value: vehicle.id,
            label: vehicle.name,
            templateId: vehicle.idoperation,
            operation: vehicle.idoperation,
            grupo: vehicle.idgrupo,
            convoy: vehicle.idconvoy,
          };
        });

        this.loadingVehicleMultiselectReady = true;
        this.hideLoadingSpinner();
      })
    }
  }
  public setDataGeofences(): Promise<any[]> {
    this.listOperations = []
    return new Promise((resolve) => {
      if (this.geofencesService.initializingGeofences === true) {
        const geocercas = this.geofencesService.getData();
        this.geocercas = geocercas.map((geocerca: any) => ({
          value: geocerca.id,
          label: geocerca.zone_name,
          templateId: geocerca.idoperation,
          color: geocerca.zone_color,
          type: geocerca.type || "polig"
        }));
        this.geocercasFiltradas = this.geocercas;
        console.log(this.geocercasFiltradas, "mostrar geocercs alerts", geocercas)
        this.loadingGeofencesMultiselectReady = true;
        this.listOperations = geocercas
          .map((v: any) => {
            let operation: any = {
              name: v.nameoperation ?? '',
              key: v.idoperation ?? 0,
            };
            return operation;
          })
          .reduce((acc: any[], _: any) => {
            if (!acc.some((o) => o.key === _.key)) {
              acc.push(_);
            }
            return acc;
          }, []);
        //this.listGeocercas.push({name : "Geocercas Sin Operacion", key: 0})
        this.listEtiquetas = [...this.geofencesService.listTag]
        this.listEtiquetas.push({ var_name: "Sin etiquetas", id: 0 })

        this.listGeocercas = geocercas
        resolve(this.geocercas); // ✅ retornamos el resultado
      } else {
        this.geofencesService.dataCompleted.subscribe(() => {
          const geocercas = this.geofencesService.getData();
          this.geocercas = geocercas.map((geocerca: any) => ({
            value: geocerca.id,
            label: geocerca.zone_name,
            templateId: geocerca.idoperation,
            color: geocerca.zone_color,
            type: geocerca.type || "polig"
          }));
          this.geocercasFiltradas = this.geocercas;
          this.loadingGeofencesMultiselectReady = true;
          this.listOperations = geocercas
            .map((v: any) => {
              let operation: any = {
                name: v.nameoperation ?? '',
                key: v.idoperation ?? 0,
              };
              return operation;
            })
            .reduce((acc: any[], _: any) => {
              if (!acc.some((o) => o.key === _.key)) {
                acc.push(_);
              }
              return acc;
            }, []);
          //this.listOperations.push({name : "Geocercas Sin Operacion", key: 0})
          this.listEtiquetas = [...this.geofencesService.listTag]
          this.listEtiquetas.push({ var_name: "Sin etiquetas", id: 0 })
          this.listGeocercas = geocercas

          resolve(this.geocercas); // ✅ retornamos el resultado cuando termina
        });
      }
    });
  }


  // util
  public convertToTreeNodes(data: any[]): TreeNode[] {
    return data.map(group => {
      // Si tiene operationGroups, convertirlas también
      if (group.operationGroups) {
        return {
          label: group.name,
          data: group,
          type: "operacion",
          expanded: false,
          children: group.operationGroups.map((opGroup: any) => ({
            label: opGroup.name,
            data: opGroup,
            type: "grupo",
            expanded: false,
            children: (opGroup.convoyList || []).map((convoy: any) => ({
              label: convoy.name,
              data: convoy,
              type: "convoy"
            }))
          }))
        } as TreeNode;
      } else {
        // Si tiene convoyList directamente
        return {
          label: group.name,
          data: group,
          expanded: false,
          children: (group.convoyList || []).map((convoy: any) => ({
            label: convoy.name,
            data: convoy,
            type: 'comvoy'
          }))
        } as TreeNode;
      }
    });
  }
  public clearTreeSelection(event: any) {
    this.labelDescriptionFilterVehicle = undefined
    this.selectConvoy = undefined;
    this.selectOperation = undefined;
    this.selectGroup = undefined;
    this.setDataVehicles();
  }
  public selectItemFromAssociation(event: any) {
    const node = event.node;

    let convoyId: number | undefined = undefined;
    let grupoId: number | undefined = undefined;
    let operacionId: number | undefined = undefined;

    // Inicializar los labels
    let convoyLabel = '';
    let grupoLabel = '';
    let operacionLabel = '';

    if (node.type === 'convoy') {
      convoyId = node.data.id;
      convoyLabel = node.label;

      grupoId = node.parent?.data?.id ?? undefined;
      grupoLabel = node.parent?.label ?? '';

      operacionId = node.parent?.parent?.data?.id ?? undefined;
      operacionLabel = node.parent?.parent?.label ?? '';
    } else if (node.type === 'grupo') {
      grupoId = node.data.id;
      grupoLabel = node.label;

      operacionId = node.parent?.data?.id ?? undefined;
      operacionLabel = node.parent?.label ?? '';
    } else if (node.type === 'operacion') {
      operacionId = node.data.id;
      operacionLabel = node.label;
    }

    const resultado = {
      operacionId,
      grupoId,
      convoyId
    };

    // Asignar IDs seleccionados
    this.selectConvoy = resultado.convoyId;
    this.selectOperation = resultado.operacionId;
    this.selectGroup = resultado.grupoId;

    // Crear descripción jerárquica
    const parts = [operacionLabel, grupoLabel, convoyLabel].filter(p => p); // elimina vacíos
    this.labelDescriptionFilterVehicle = parts.join(' / ');

    console.log('Selección jerárquica:', resultado);
    console.log('Label:', this.labelDescriptionFilterVehicle);

    this.filterVehicleByCascadeSelected();
  }

  hideLoadingSpinner() {
    if (
      this.loadingAlertDropdownReady &&
      this.loadingVehicleMultiselectReady &&
      this.loadingGeofencesMultiselectReady
    ) {
      this.spinner.hide('loadingAlertData');
    }
  }

  public updateSoundSystem(alert: any) {

    // Obtén todos los elementos de la lista de sonidos hasta el id 27
    let sonidosObtenidos = this.alertService.listaSonidos.filter(
      (sonido: { id: any }) => sonido.id <= 26
    );

    
    const soundId = this.alertService.getSoundConfigurationFromAlerts(alert.slug);
    if (soundId) {
      const vozPersonalizada = this.alertService.listaSonidos.find(
        (sonido: { id: any }) => sonido.id === soundId
      );
      if (vozPersonalizada) {
        sonidosObtenidos = [vozPersonalizada, ...sonidosObtenidos];
      }
    }

    if (sonidosObtenidos.length > 0) {
      console.log('Sonidos obtenidos:', sonidosObtenidos);
      this.listaSonidos = sonidosObtenidos;
    }

  }
  // case operaciones and grupoas
  public selectOperation: number | undefined;
  public selectGroup: number | undefined;
  public selectConvoy: number | undefined;

  filterVehicleByCascadeSelected() {
    this.setDataVehicles()
    this.vehicles = this.vehicles.filter((vehicle) => {
      if (this.selectOperation != undefined) {
        if (this.selectGroup != undefined) {
          if (this.selectConvoy != undefined) {
            return this.selectConvoy == vehicle.convoy && this.selectGroup == vehicle.grupo && this.selectOperation == vehicle.operation
          } else {
            return this.selectGroup == vehicle.grupo && this.selectOperation == vehicle.operation
          }
        } else {
          return this.selectOperation == vehicle.operation
        }
      } else {
        return true
      }
    })
  }

  // configuracion de audio
  audio = new Audio();

  playAudio(path: string) {
    if (typeof path != 'undefined' && path != '') {
      if (this.audio.currentSrc != '' && !this.audio.ended) {
        this.audio.pause();
      }
      this.audio = new Audio('assets/' + path);
      let audioPromise = this.audio.play();

      if (audioPromise !== undefined) {
        audioPromise
          .then(() => {
            //console.log('Playing notification sound')
          })
          .catch((error: any) => {
            //console.log(error);
            // Auto-play was prevented
          });
      }
    }
  }


  clickShowPanel(): void {
    $('#panelMonitoreo').show('slow');
    let nomComponent = 'ALERTS';
    this.panelService.nombreComponente = nomComponent;
    const panelItem = this.panelService.options.find((opt) => {
      return opt.id == nomComponent
    })
    if (panelItem) {
      this.panelService.nombreCabecera = panelItem.name
    }
  }


  // UTIL
  isInArray(value: any, array: any[]) {
    return array.indexOf(value) > -1;
  }

  validateEmail(email: any) {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
}
